import type { Theme } from "@todoer/shared";

const KEY = "todoer.theme";
let media: MediaQueryList | null = null;

function paint(theme: Theme) {
  const dark = theme === "dark" || (theme === "system" && window.matchMedia("(prefers-color-scheme: dark)").matches);
  document.documentElement.classList.toggle("dark", dark);
  document.documentElement.style.colorScheme = dark ? "dark" : "light";
  // Browser chrome (address bar, PWA status bar) follows the app surface, not the OS.
  for (const meta of document.querySelectorAll<HTMLMetaElement>('meta[name="theme-color"]')) {
    meta.removeAttribute("media");
    meta.content = dark ? "#0f1012" : "#fafafa";
  }
}

/** Applies a theme now and keeps following the OS when it is "system". */
export function applyTheme(theme: Theme): void {
  try { localStorage.setItem(KEY, theme); } catch { /* ignore */ }
  paint(theme);
  media?.removeEventListener("change", onChange);
  media = window.matchMedia("(prefers-color-scheme: dark)");
  media.addEventListener("change", onChange);
}
function onChange() {
  let t: Theme = "system";
  try { t = (localStorage.getItem(KEY) as Theme) ?? "system"; } catch { /* ignore */ }
  paint(t);
}

/** Applies the last used theme before the user record has loaded, to avoid a flash. */
export function applyCachedTheme(): void {
  let t: Theme = "system";
  try { t = (localStorage.getItem(KEY) as Theme) ?? "system"; } catch { /* ignore */ }
  applyTheme(t);
}
